<template>
  <div>
    <title-all-transaction-client
      title="Transações"
    ></title-all-transaction-client>
    <history-client></history-client>
  </div>
</template>

<script>
import HistoryClient from "./transactions/HistoryClient";
import Title from "../geral/Title";

export default {
  name: "TransactionsClient",
  components: { "title-all-transaction-client": Title, HistoryClient }
};
</script>

<style scoped></style>
